import styled from "styled-components";
import { Space } from "antd";


export const SubTitle = styled.div`
  margin: 0 18px 24px;
  color: var(--white, #FFF);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const StyledInput = styled.input`
  width: 52px !important;
  height: 61px !important;
  border-radius: 8px !important;
  text-align: center !important;
  border:  ${(props) => (props.status === "error" ? "1px solid red" : "1px solid #DDD7CD")} !important;
  padding: 0;
  margin: 30px 0 0 0;
  color: #13100F;
  text-align: center;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  &:focus{
    border: 2px solid #F9DF35;
  }

  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 380px) {
    width: 45px !important;
    height: 50px !important;
    font-size: 18px !important;

  }
  @media screen and (max-width: 320px) {
    width: 40px !important;
    height: 40px !important;
    font-size: 16px !important;

  }
`;

export const BottomBox = styled(Space)`
  width: 100%;
  margin: 16px 0;

  .ant-space-item:nth-child(1) {
    flex: 1;
  }
`;

export const BottomText = styled.div`
  cursor: pointer;
  color: #DB7802;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const TimeText = styled.div`
  color:  #13100F;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;


